import type { CriterionLocaleBundle } from '../localize'

/** Unofficial translations from docs/kata — English scoring text remains authoritative. */
export const koshikiNoKataCriteriaI18n: CriterionLocaleBundle = {
  ja: {
    'koshiki-gen-tori-uke-sides': {
      text: '取は正面（Shomen）の左側、受は右側に位置する。',
    },
    'koshiki-gen-standing-bow': {
      text: '互いの立礼では踵を離す。',
    },
    'koshiki-gen-kneeling-bow': {
      text: '座礼。',
    },
    'koshiki-gen-shizen-steps': {
      text: '取は正面に向かい、二歩進んで自然本体（shizen-hontai）となり、さらに大きく一歩進んで自然本体となる。',
    },
    'koshiki-gen-kurai-dori': {
      text: '位取り（Kurai-dori）の姿勢。',
    },
    'koshiki-gen-dai-no-ji': {
      text: '大の字（Dai-no-ji）の姿勢。',
    },
    'koshiki-gen-ukemi': {
      text: '受身（Ukemi）。',
    },
    'koshiki-gen-target': {
      text: '攻撃の目標。',
    },
    'koshiki-gen-distance': {
      text: '間合い。',
    },
    'koshiki-gen-interaction': {
      text: '相互の連係。',
    },
    'koshiki-tai-1': {
      text: '受は左足から静かに六歩前進し、右足を取の左足のすぐ前に置く。',
    },
    'koshiki-tai-2': {
      text: '右手で取の帯の後ろ側、左手で前側を握る。',
    },
    'koshiki-tai-3': {
      text: '左足で取の右膝頭を打とうとする。',
    },
    'koshiki-tai-4': {
      text: '左足を後ろへ振り戻して両手を強く引き、腰投（Koshi-nage）で取を投げようとする。',
    },
    'koshiki-tai-5': {
      text: '取は左手を受の右腋下に入れて左腰を抱え、右の手のひらを受の左胸に当てる。',
    },
    'koshiki-tai-6': {
      text: '継ぎ足（tsugi-ashi）で自分の左後隅へ受を押し、受は歩み足（ayumi-ashi）で後退する。',
    },
    'koshiki-tai-7': {
      text: '取は受を後方へ崩し、右膝を畳につく。受は投げられる際に受身を取る。',
    },
    'koshiki-tai-8': {
      text: '取は左足を左へ向け、位取りの姿勢になる。',
    },
    'koshiki-yume-no-uchi-1': {
      text: '取は「体」を始めた位置の左斜め、やや後方へ移る。受は「体」の開始位置に戻る。',
    },
    'koshiki-yume-no-uchi-2': {
      text: '受は六歩進んで取に近づき、右足を取の左足の前に置く。「体」と同様に、受は取を投げようとし、取は受を制しようとする。',
    },
    'koshiki-yume-no-uchi-3': {
      text: '受は後方へ崩れ、左足を少し引いて姿勢を立て直そうとする。',
    },
    'koshiki-yume-no-uchi-4': {
      text: '取は攻撃方向を変え、左手を受の背の右側へ、右手を受の左上腕へ移し、受の体を前方へ持ち上げる。',
    },
    'koshiki-yume-no-uchi-5': {
      text: '受は左足を一歩進める。取は体を内側へ回し、左足を右足の横へ引き、小刻みに数歩後退する。',
    },
    'koshiki-yume-no-uchi-6': {
      text: '受は取の体を斜めに越えて投げられ、取は畳の上で両腕と両脚を広げて大の字になる。',
    },
    'koshiki-ryokuhi-1': {
      text: '受と取は中央で約 60 cm 離れて向かい合う。受は右手を左手の上にして、両手で取の帯の前側を上から握ろうとする。',
    },
    'koshiki-ryokuhi-2': {
      text: '取は右足を自分の右後隅へ少し引き、左手を親指が上になるようにして受の右手首を外から内へ払い、握って前へ引く。',
    },
    'koshiki-ryokuhi-3': {
      text: '取は右手を左手の上に重ね、手の甲を下、親指を上にして受の右肘の上側を外から握る。受を自分の方へ引き、右前隅へ導く。',
    },
    'koshiki-ryokuhi-4': {
      text: '継ぎ足で受を前へ進ませ、受の右肘を押し上げながら右前隅へ移り、左手で受の左上腕を制する。',
    },
    'koshiki-ryokuhi-5': {
      text: '数歩移動して受の体を持ち上げ、受は爪先立ちになる。',
    },
    'koshiki-ryokuhi-6': {
      text: '取は両手を受の両肩に置き、左足を大きく後退させて左膝を畳につき、受を引き倒す。',
    },
    'koshiki-mizu-guruma-1': {
      text: '受と取は中央で約 60 cm 離れて向かい合う。受は右手を左手の上にし、両手で取の帯の前側を上から握ろうとする。',
    },
    'koshiki-mizu-guruma-2': {
      text: '取は右足を大きく引き、右手で受の右手首を握り、左手を受の右肘の少し上に当て、受を右斜め下へ引こうとする。',
    },
    'koshiki-mizu-guruma-3': {
      text: '受の反応に従い、取は右足を受の右足の外側へ大きく踏み出す。左足を受の側方へ移し、体を右へ回す。',
    },
    'koshiki-mizu-guruma-4': {
      text: '受の右手の甲を受の額に押し当て、左手で受の腰の後ろ側を抱え、後方へ押して崩す。',
    },
    'koshiki-mizu-guruma-5': {
      text: '受は後方へ崩れ、左足を少し引いて姿勢を立て直そうとする。取は攻撃方向を変え、左手を受の背の右側へ、右手を受の左上腕へ移し、受の体を前方へ持ち上げて崩す。',
    },
    'koshiki-mizu-guruma-6': {
      text: '受は左足を一歩進める。取は体を内側へ回し、左足を右足の横へ引き、小刻みに数歩後退する。受は取の体を斜めに越えて投げられ、取は畳の上で両腕と両脚を広げて大の字になる。',
    },
    'koshiki-mizu-nagare-1': {
      text: '取と受は斜めの線上で約 5 m 離れ、自然本体で立つ。取は正面の右側にいる。両者は数歩進んで近づく。受は右手を背の右側に置き、左の手のひらを下に向けて徐々に上げる。',
    },
    'koshiki-mizu-nagare-2': {
      text: '間合いに達すると、受は左足を大きく踏み出し、左手の四指で取の襟を引っ掛けようとする。取は瞬時に右足を少し引く。受は襟を掛けられず前方へ崩れる。',
    },
    'koshiki-mizu-nagare-3': {
      text: '取は右足、左足の順に継ぎ足で素早く退き、右手で受の左手を親指を上にして握り、前上方へ引き、左手を受の上腕の下に当てて押し上げる。',
    },
    'koshiki-mizu-nagare-4': {
      text: '続いて左の手のひらを受の上腕の内側に当て、外へ押す。取は右足を引き、右膝を畳につき、受を前方へ引き倒す。',
    },
    'koshiki-hiki-otoshi-1': {
      text: '取と受は「水流」と反対側の位置で約 5 m 離れ、自然本体で向かい合う。両者は数歩進んで近づく。',
    },
    'koshiki-hiki-otoshi-2': {
      text: '受は右足を踏み出し、右手で帯の高さの取の左腰をつかもうとする。',
    },
    'koshiki-hiki-otoshi-3': {
      text: '取は左足・右足の順に継ぎ足で退き、攻撃をかわす。受は腰をつかめず前方へ崩れる。',
    },
    'koshiki-hiki-otoshi-4': {
      text: '取は左手で受の右手首を上から握り、右手を親指が上になるようにして受の右上腕に当てる。再び左足を引いて左膝を畳につき、両手で受を前方へ引き倒す。',
    },
    'koshiki-ko-daore-1': {
      text: '取と受は「曳落」と反対側の位置で約 5 m 離れ、自然本体で向かい合う。両者は数歩進んで近づく。',
    },
    'koshiki-ko-daore-2': {
      text: '取は数歩前進し、右手を徐々に前へ上げて手刀（Te-gatana）にする。親指を上にし、四指をそろえて伸ばす。右足を踏み出し、手刀で受の烏兎（uto、眉間）を突こうとする。',
    },
    'koshiki-ko-daore-3': {
      text: '受は体を右へ回して顔をそらし、攻撃をかわす。右手の四指を上にして取の右手首を握り、前へ引く。左足を取の体の前へ踏み出し、左手を取の背に深く入れ、取の腰を自分の左腰へ抱き寄せて投げようとする。',
    },
    'koshiki-ko-daore-4': {
      text: '取は右腕を伸ばし、前腕の小指側を受の顔に押し当てて制する。右腰を受の左腰の後ろに置き、左手を受の帯の前側に当て、右足から継ぎ足で右斜め後方へ移る。',
    },
    'koshiki-ko-daore-5': {
      text: '受を右後隅へ崩し、左足を引いて左膝を右踵の近くにつき、両手で受を後方へ押し倒す。右足を右へ向け、位取りの姿勢になる。',
    },
    'koshiki-uchikudaki-1': {
      text: '取と受は「虚倒」と反対側の位置で約 5 m 離れ、自然本体で向かい合う。両者は数歩進んで近づく。',
    },
    'koshiki-uchikudaki-2': {
      text: '取は数歩前進し、左手を徐々に前へ上げ、親指を上、四指をそろえて伸ばした手刀にする。左足を踏み出し、受の腹部の水月（suigetsu）を手刀で突こうとする。',
    },
    'koshiki-uchikudaki-3': {
      text: '受は体を左へ回して攻撃をかわす。左手の四指を上にして取の手首を握り、前へ引く。右足を取の体の前へ踏み出し、右手を取の背に深く入れ、取の腰を抱えて投げようとする。',
    },
    'koshiki-uchikudaki-4': {
      text: '取は左腕を伸ばし、小指側が上になるように手首を回し、前からすくい上げるように受の腰を抱え、右手を受の帯の前側に当てる。左足から継ぎ足で左斜め後方へ移る。',
    },
    'koshiki-uchikudaki-5': {
      text: '受を左後隅へ押して崩す。右足を引いて右膝を左踵の近くにつき、両手で受を後方へ押し倒す。左足を左へ向け、位取りの姿勢になる。',
    },
    'koshiki-tani-otoshi-1': {
      text: '取：中央の右側、形の軸線から正面側へ約 50 cm の位置で、正面に向かい自然本体で立つ。受は取の後方約 3 m に自然本体で立ち、受の右足と取の左足を同じ線上に置く。',
    },
    'koshiki-tani-otoshi-2': {
      text: '受は取の左後ろ約一歩の間合いまで進み、左足を取の左足の横に置く。右手を取の右肩の後ろ、左手を取の腹の前に当て、取を前方へ押し倒そうとする。',
    },
    'koshiki-tani-otoshi-3': {
      text: '取は上体を深く前に曲げて応じ、右手で受の右手を小指側から握る。受は右足を進める。取は右手を上げ、左手を受の左腰へ移し、左足を受の両足の後ろへ移す。',
    },
    'koshiki-tani-otoshi-4': {
      text: '右手で受の右手を一気に斜め上へ上げ、受の体を持ち上げる。左足から継ぎ足で左斜め後方へ数歩移り、受を左後隅へ崩し、右膝を左踵の近くに置く。左足を左へ向け、位取りの姿勢になる。',
    },
    'koshiki-kuruma-daore-1': {
      text: '取：中央の右側、正面側の形の軸線の後方約 50 cm の位置で、正面に向かい自然本体で立つ。受は取の後方約 3 m に自然本体で立ち、受の右足と取の左足を同じ線上に置く。',
    },
    'koshiki-kuruma-daore-2': {
      text: '受は両手を上げ、右手を取の右肩の後ろ、左手を左肩の前に当て、取の体をねじろうとする。取は右足を軸に回り、左足、右足の順に受の右足の右側へ踏み込む。',
    },
    'koshiki-kuruma-daore-3': {
      text: '両手を親指が上になるようにして受の腋の周囲に当て、持ち上げて崩す。受を自分の体の上へ投げ、取は大の字になる。受は取の体を斜めに跳び越え、立ち上がる。',
    },
    'koshiki-shikoro-dori-1': {
      text: '取は中央へ移り、正面の左側で自然本体となる。受は約 30 cm の間合いで取に向かい合う。受は左の手のひらを内に返し、取の帯の前側を上から握ろうとする。取は腰を少し引いて攻撃をかわす。',
    },
    'koshiki-shikoro-dori-2': {
      text: '右手を親指が上になるようにして受の左手首を払い握り、左下方へ引く。左の手のひらを受の顎の左側に当て、右斜め上へ押す。受は左足を軸に回り、右足を左足のすぐ横へ戻して後方へ崩れる。',
    },
    'koshiki-shikoro-dori-3': {
      text: '取は右手を後ろから受の右肩へ移し、左手を前から受の左肩へ移す。左足を大きく引いて左膝を畳につく。',
    },
    'koshiki-shikoro-dori-4': {
      text: '受は右足を少し引いて後方へ倒れ、受身を取る。',
    },
    'koshiki-shikoro-gaeshi-1': {
      text: '取は中央へ移り、正面の右側で自然本体となる。受は約 30 cm の間合いで向かい合う。左の手のひらを内に返して取の帯の前側を上から握り、右足を大きく引いて体を右へ回し、取の体を自分の左腰へ引き寄せる。',
    },
    'koshiki-shikoro-gaeshi-2': {
      text: '取は右足を受の後ろへ大きく踏み出す。右手を受の左こめかみ、左手を受の顎の右側に当て、前へ引いて首をねじる。右手を指が前を向くように受の右肩に置き、左手を受の左肩に置いて後方へ崩す。',
    },
    'koshiki-shikoro-gaeshi-3': {
      text: '腰を下げ、右脚の内側で受の左脚を後ろから払い、受を仰向けに引き倒して両脚を伸ばして座る。受は受身を取り、両脚を伸ばして座る。',
    },
    'koshiki-yudachi-1': {
      text: '取は中央へ移り、正面の左側で自然本体となる。受は約 60 cm の間合いで向かい合う。取は両手で受の両襟を握り、次に両襟を右手にまとめ、人差し指を両襟の間に入れる。',
    },
    'koshiki-yudachi-2': {
      text: '受は左足を一歩進め、左手で取の右肘の下を支える。取は右足を引く。受は右足を大きく踏み出し、右手で取の左腰を握って腰投で投げようとする。',
    },
    'koshiki-yudachi-3': {
      text: '取は左手で受の右腕を握って左腋下に抱え、左足を引いて左膝を畳につき、両手で受を前方へ引き倒す。',
    },
    'koshiki-taki-otoshi-1': {
      text: '取は中央へ移り、正面の右側で自然本体となる。受は約 60 cm の間合いで向かい合う。取は両手で受の両襟を握り、次に両襟を右手にまとめ、人差し指を両襟の間に入れる。',
    },
    'koshiki-taki-otoshi-2': {
      text: '受は左足を一歩進め、左手で取の右肘の下を支える。取は右足を引く。受は右足を大きく踏み出し、右手を取の左肩越しに伸ばして帯の後ろ側を握り、腰投で投げようとする。',
    },
    'koshiki-taki-otoshi-3': {
      text: '取は体を左へ回して左手で受の腰を抱え、受を左後方へ数歩押して崩す。受は後方へ崩れ、左足を少し引いて姿勢を立て直そうとする。',
    },
    'koshiki-taki-otoshi-4': {
      text: '取は攻撃方向を変え、左手を受の背の右側へ移し、右手の人差し指を受の両襟の間に入れたまま受の体を前方へ持ち上げる。受は左足を一歩進める。',
    },
    'koshiki-taki-otoshi-5': {
      text: '取は体を内側へ回し、左足を右足の横へ引き、小刻みに数歩後退する。受は取の体を斜めに越えて投げられ、取は畳の上で両腕と両脚を広げて大の字になる。',
    },
    'koshiki-mi-kudaki-1': {
      text: '取は「夢中」の開始位置より一歩後ろで、正面に向かって自然本体で立つ。受は「夢中」の開始位置と同じ場所で、取に向かって自然本体で立つ。',
    },
    'koshiki-mi-kudaki-2': {
      text: '受は左足から六歩進み、右足を取の左足のすぐ前に置く。右手で取の帯の後ろ側、左手で前側を握る。左足で取の右膝頭を打とうとし、左足を後ろへ振り戻して両手を強く引く。',
    },
    'koshiki-mi-kudaki-3': {
      text: '取は右手で受の左手首を上から握り、左手の握りを外す。左手を小指側が上になるように回し、左腕を受の左腋下に入れて体を後ろ上方へ押す。左足から継ぎ足で左後方へ小刻みに数歩移る。',
    },
    'koshiki-mi-kudaki-4': {
      text: '受は後方へ崩れ、左足を少し引いて姿勢を立て直そうとし、左足を一歩前へ進める。取は攻撃方向を変え、右足を受の右足の外側へ移し、受の両脚の下へ仰向けに身を捨てる。',
    },
    'koshiki-mi-kudaki-5': {
      text: '受は取の体を斜めに越えて投げられ、立ち上がる。',
    },
    'koshiki-kuruma-gaeshi-1': {
      text: '取と受は斜めの線上で向かい合い、取は正面の左側に立つ。両者は素早く近づく。受は両手で取の両肩を突く。取は両手を受の上腕の下側に当て、親指を外に向ける。',
    },
    'koshiki-kuruma-gaeshi-2': {
      text: '左足、右足の順に受の右足の外側へ踏み出し、仰向けに身を捨てる。受は取の体を斜めに越えて投げられ、立ち上がる。',
    },
    'koshiki-mizu-iri-1': {
      text: '取と受は斜めの線上で向かい合い、取は正面の左側に立つ。両者は素早く近づく。受は右足を踏み出し、右手で取の左肩の側を突く。',
    },
    'koshiki-mizu-iri-2': {
      text: '取は左の手のひらを外に返し、受の右手首を内側から握る。右の手のひらを上、親指を内に向け、受の右腋下に入れる。左足、右足の順に受の右足の外側へ踏み込み、仰向けに身を捨てる。受は取の体を斜めに越えて投げられ、立ち上がる。',
    },
    'koshiki-ryusetsu-1': {
      text: '取と受は斜めの線上で向かい合い、取は正面の右側に立つ。受は数歩前進し、取は数歩素早く前進して近づく。取は右足を踏み出し、右手の甲を上にして指先を下げながら、受の顔、目に向けて上げる。',
    },
    'koshiki-ryusetsu-2': {
      text: '受は頭を少し後ろへ反らす。取は右手で受の左側の襟を握り、左手を受の右腋下に入れる。',
    },
    'koshiki-ryusetsu-3': {
      text: '左足、右足の順に受の右足の外側へ踏み込み、仰向けに身を捨てる。受は取の体を斜めに越えて投げられ、立ち上がる。',
    },
    'koshiki-sakaotoshi-1': {
      text: '取と受は斜めの線上で向かい合い、取は正面の左側に立つ。受は数歩前進し、取は数歩素早く前進して近づく。',
    },
    'koshiki-sakaotoshi-2': {
      text: '受は左足を踏み出し、左手を親指が上、四指をそろえて伸ばした手刀にし、取の腹部の水月を鋭く突く。取は右足を一歩引いて左構えになる。',
    },
    'koshiki-sakaotoshi-3': {
      text: '右手で受の突いた手の手首を上から握り、左の手のひらを親指が上になるようにして受の左上腕の内側に当てる。取は立ち姿勢を保ったまま受を引き倒す。受は前方へ横向きに回転する。',
    },
    'koshiki-yukiore-1': {
      text: '取は受の方へ数歩進み、受が立ち上がると、受に背を向けて前へ歩く。受は後ろから続く。',
    },
    'koshiki-yukiore-2': {
      text: '右足を取の右足の外側へ踏み出し、取の両腕の上から体を抱えようとする。取は両腕を開き、受の右腕を上から抱える。右手は受の上腕、左手は前腕に当てる。',
    },
    'koshiki-yukiore-3': {
      text: '右膝を畳について体を下げ、受を自分の背の上から投げる。受は前方へ回転する。',
    },
    'koshiki-iwa-nami-1': {
      text: '受は素早く立ち上がって取に向き合う。取は受に一、二歩近づき、両手の甲を上にして受の顔へ上げ、目に目潰しの当身を加える。受は頭を少し後ろへ反らす。',
    },
    'koshiki-iwa-nami-2': {
      text: '受が頭を戻すと、取は両手で受の両側の襟を握る。受の体を持ち上げて崩す。',
    },
    'koshiki-iwa-nami-3': {
      text: '左足、右足の順に受の右足の外側へ踏み込み、仰向けに身を捨てる。受は取の体を斜めに越えて投げられ、取は畳の上で両腕と両脚を広げて大の字になる。',
    },
  },
  'zh-Hant': {
    'koshiki-gen-tori-uke-sides': {
      text: '取位於正面（Shomen）的左側，受位於右側。',
    },
    'koshiki-gen-standing-bow': {
      text: '雙方互相立禮時，腳跟分開。',
    },
    'koshiki-gen-kneeling-bow': {
      text: '跪姿行禮。',
    },
    'koshiki-gen-shizen-steps': {
      text: '取面向正面，走兩步，採自然本體（shizen-hontai），再大步踏出一步，採自然本體。',
    },
    'koshiki-gen-kurai-dori': {
      text: 'Kurai-dori 姿勢。',
    },
    'koshiki-gen-dai-no-ji': {
      text: '大字形（Dai-no-ji）姿勢。',
    },
    'koshiki-gen-ukemi': {
      text: '受身（Ukemi）。',
    },
    'koshiki-gen-target': {
      text: '攻擊目標。',
    },
    'koshiki-gen-distance': {
      text: '距離。',
    },
    'koshiki-gen-interaction': {
      text: '雙方的相互配合。',
    },
    'koshiki-tai-1': {
      text: '受從左腳起安靜前進六步，右腳置於取的左腳正前方。',
    },
    'koshiki-tai-2': {
      text: '受右手握取腰帶後側，左手握前側。',
    },
    'koshiki-tai-3': {
      text: '嘗試以左腳擊取的右膝蓋。',
    },
    'koshiki-tai-4': {
      text: '左腳向後擺，雙手用力拉，嘗試以腰投（Koshi-nage）摔出取。',
    },
    'koshiki-tai-5': {
      text: '取將左手伸入受的右腋下，控制受的左髖，右掌置於受的左胸。',
    },
    'koshiki-tai-6': {
      text: '取以繼足（tsugi-ashi）向自己的左後隅推受，受以步足（ayumi-ashi）後退。',
    },
    'koshiki-tai-7': {
      text: '取使受向後失去平衡，右膝著地；受被摔倒時作受身。',
    },
    'koshiki-tai-8': {
      text: '取左腳向左轉，採 Kurai-dori 姿勢。',
    },
    'koshiki-yume-no-uchi-1': {
      text: '取移至「体」開始位置的左斜方、稍後的位置。受回到「体」的起始位置。',
    },
    'koshiki-yume-no-uchi-2': {
      text: '受前進六步接近取，右腳置於取的左腳前方。受嘗試摔出取，取嘗試控制受，方式與「体」相同。',
    },
    'koshiki-yume-no-uchi-3': {
      text: '受向後失去平衡，左腳稍退，嘗試恢復姿勢。',
    },
    'koshiki-yume-no-uchi-4': {
      text: '取改變攻擊方向，左手移至受背部右側，右手置於受的左上臂，將受的身體向前抬起。',
    },
    'koshiki-yume-no-uchi-5': {
      text: '受左腳前進一步。取向內轉身，左腳退至右腳旁，再小步後退數步。',
    },
    'koshiki-yume-no-uchi-6': {
      text: '受斜向越過取的身體被摔出；取在榻榻米上張開雙臂及雙腿，呈大字形。',
    },
    'koshiki-ryokuhi-1': {
      text: '受與取在中央相距約 60 厘米。受嘗試以雙手從上方握取腰帶的前側，右手在左手上方。',
    },
    'koshiki-ryokuhi-2': {
      text: '取右腳向自己的右後隅稍退一步，左手拇指朝上，從外向內撥開受的右手腕，再握其手腕向前拉。',
    },
    'koshiki-ryokuhi-3': {
      text: '取將右手放在左手上方，手背朝下、拇指朝上，從外側握受右肘上方，將受拉近，使其移向取的右前隅。',
    },
    'koshiki-ryokuhi-4': {
      text: '取以繼足推受向前，移向右前隅，同時將受的右肘向上推，以左手控制受的左上臂。',
    },
    'koshiki-ryokuhi-5': {
      text: '取移動數步，抬起受的身體；受踮腳站立。',
    },
    'koshiki-ryokuhi-6': {
      text: '取雙手置於受的雙肩，左腳大步後退，左膝著地，將受向下拉。',
    },
    'koshiki-mizu-guruma-1': {
      text: '受與取在中央相距約 60 厘米。受嘗試以雙手從上方握取腰帶前側，右手在左手上方。',
    },
    'koshiki-mizu-guruma-2': {
      text: '取右腳大步後退，右手握受的右手腕，左手置於受右肘稍上方，嘗試將受斜向右下方拉。',
    },
    'koshiki-mizu-guruma-3': {
      text: '順應受的反應，取右腳大步踏至受右腳外側，左腳移至受的側方，身體向右轉。',
    },
    'koshiki-mizu-guruma-4': {
      text: '取將受的右手背壓在受的前額上，以左手控制受髖部後側，向後推受，使其失去平衡。',
    },
    'koshiki-mizu-guruma-5': {
      text: '受向後失去平衡，左腳稍退，嘗試恢復姿勢。取改變攻擊方向，左手移至受背部右側，右手置於受的左上臂，將受身體向前抬起，使其失去平衡。',
    },
    'koshiki-mizu-guruma-6': {
      text: '受左腳前進一步。取向內轉身，左腳退至右腳旁，小步後退數步。受斜向越過取的身體被摔出；取張開雙臂及雙腿，呈大字形。',
    },
    'koshiki-mizu-nagare-1': {
      text: '取與受在斜線上以自然本體站立，相距約 5 米；取位於正面的右側。雙方走數步互相接近。受右手置於背部右側，左手掌心朝下，逐漸抬起。',
    },
    'koshiki-mizu-nagare-2': {
      text: '到達適當距離時，受左腳大步前進，嘗試以左手四指勾取的衣領。取瞬間右腳稍退，受未能勾住衣領，向前失去平衡。',
    },
    'koshiki-mizu-nagare-3': {
      text: '取迅速以繼足依右腳、左腳順序後退，右手拇指在上握受的左手，向前上方拉，左手置於受的上臂下方，向上推。',
    },
    'koshiki-mizu-nagare-4': {
      text: '再將左掌置於受的上臂內側，向外推。取右腳後退，右膝著榻榻米，將受向前下方拉倒。',
    },
    'koshiki-hiki-otoshi-1': {
      text: '取與受在與「水流」相反的位置，以自然本體相對，相距約 5 米。雙方走數步接近。',
    },
    'koshiki-hiki-otoshi-2': {
      text: '受右腳前進，嘗試以右手在腰帶高度抓取的左腰。',
    },
    'koshiki-hiki-otoshi-3': {
      text: '取以繼足依左腳、右腳順序後退，避開攻擊。受未能抓住取的腰，向前失去平衡。',
    },
    'koshiki-hiki-otoshi-4': {
      text: '取左手從上方握受的右手腕，右手拇指朝上，置於受的右上臂。取再次左腳後退，左膝著榻榻米，以雙手將受向前下方拉倒。',
    },
    'koshiki-ko-daore-1': {
      text: '取與受在與「曳落」相反的位置，以自然本體相對，相距約 5 米。雙方走數步接近。',
    },
    'koshiki-ko-daore-2': {
      text: '取前進數步，右手逐漸向前抬起，作手刀（Te-gatana），拇指朝上，其餘四指併攏伸直。取右腳前進，嘗試以手刀突刺受的眉間（uto）。',
    },
    'koshiki-ko-daore-3': {
      text: '受身體向右轉並轉臉避開攻擊，右手四指朝上握取的右手腕，向前拉；左腳踏至取身前，左手深入取的背部，將取的髖部抱向自己的左髖，嘗試摔出取。',
    },
    'koshiki-ko-daore-4': {
      text: '取伸直右臂，以前臂小指側壓受的臉控制；右髖置於受左髖後方，左手置於受腰帶前側，以右腳帶動繼足斜向右後方移動。',
    },
    'koshiki-ko-daore-5': {
      text: '取使受向右後隅失去平衡，左腳後退，使左膝靠近右腳跟，雙手將受向後推倒。取右腳向右轉，採 Kurai-dori 姿勢。',
    },
    'koshiki-uchikudaki-1': {
      text: '取與受在與「虚倒」相反的位置，以自然本體相對，相距約 5 米。雙方走數步接近。',
    },
    'koshiki-uchikudaki-2': {
      text: '取前進數步，左手逐漸向前抬起，作手刀，拇指朝上，其餘四指併攏伸直。取左腳前進，嘗試以手刀突刺受的腹部水月（suigetsu）。',
    },
    'koshiki-uchikudaki-3': {
      text: '受身體向左轉避開攻擊，左手四指朝上握取的手腕並向前拉。受右腳踏至取身前，右手深入取的背部，抱住取的髖部，嘗試摔出取。',
    },
    'koshiki-uchikudaki-4': {
      text: '取伸直左臂，轉動手腕使小指側朝上，從前方如托起般抱住受的髖部，右手置於受腰帶前側。取以左腳帶動繼足斜向左後方移動。',
    },
    'koshiki-uchikudaki-5': {
      text: '將受推向左後隅使其失去平衡；右腳後退，使右膝靠近左腳跟，雙手將受向後推倒。取左腳向左轉，採 Kurai-dori 姿勢。',
    },
    'koshiki-tani-otoshi-1': {
      text: '取：在中央右側、朝正面一側離形的軸線約 50 厘米處，以自然本體面向正面。受在取後方約 3 米，以自然本體站立，受的右腳與取的左腳在同一直線上。',
    },
    'koshiki-tani-otoshi-2': {
      text: '受移至取的左後方約一步距離，左腳置於取的左腳旁；右手置於取的右肩後側，左手置於取的腹部前側，嘗試將取向前推倒。',
    },
    'koshiki-tani-otoshi-3': {
      text: '取上身深向前屈以應對，右手從受右手的小指側握住。受右腳前進。取抬右手，左手移至受的左髖，左腳移至受雙腳後方。',
    },
    'koshiki-tani-otoshi-4': {
      text: '右手將受的右手一舉斜向上抬，以抬起受的身體。取以左腳帶動繼足斜向左後方移動數步，使受向左後隅失去平衡，右膝置於左腳跟附近。取左腳向左轉，採 Kurai-dori 姿勢。',
    },
    'koshiki-kuruma-daore-1': {
      text: '取：在中央右側、朝正面一側的形軸線後方約 50 厘米處，以自然本體面向正面。受在取後方約 3 米，以自然本體站立，受的右腳與取的左腳在同一直線上。',
    },
    'koshiki-kuruma-daore-2': {
      text: '受抬雙手，右手置於取右肩後側，左手置於取左肩前側，嘗試扭轉取的身體。取以右腳為軸轉身，依左腳、右腳順序踏至受右腳的右側。',
    },
    'koshiki-kuruma-daore-3': {
      text: '雙手置於受的腋部周圍，拇指朝上，抬起受並使其失去平衡。取將受摔越自己的身體，自己呈大字形。受斜向跳越取的身體並站起。',
    },
    'koshiki-shikoro-dori-1': {
      text: '取移至中央，在正面的左側採自然本體；受在約 30 厘米處面向取。受左掌向內轉，嘗試從上方握取腰帶前側。取髖部稍退避開攻擊。',
    },
    'koshiki-shikoro-dori-2': {
      text: '右手拇指朝上，撥開並握受的左手腕，向左下方拉。取左掌壓受下巴左側，斜向右上方推。受以左腳為軸轉身，右腳轉回至左腳旁，向後失去平衡。',
    },
    'koshiki-shikoro-dori-3': {
      text: '取右手從後方移至受的右肩，左手從前方移至受的左肩。取左腳大步後退，左膝著榻榻米。',
    },
    'koshiki-shikoro-dori-4': {
      text: '受右腳稍退，向後倒下並作受身。',
    },
    'koshiki-shikoro-gaeshi-1': {
      text: '取移至中央，在正面的右側採自然本體；受在約 30 厘米處面向取。受左掌向內轉，從上方握取腰帶前側，右腳大步後退，身體向右轉，將取的身體拉向自己的左髖。',
    },
    'koshiki-shikoro-gaeshi-2': {
      text: '取右腳大步踏至受的後方，右手置於受的左太陽穴，左手置於受下巴右側，向前拉並扭轉受的頸部。取右手置於受的右肩，手指朝前，左手置於受的左肩，使受向後失去平衡。',
    },
    'koshiki-shikoro-gaeshi-3': {
      text: '取降低髖部，以右腿內側從後方掃受的左腿，將受向後拉倒，自己雙腿伸直坐下。受作受身，雙腿伸直坐下。',
    },
    'koshiki-yudachi-1': {
      text: '取移至中央，在正面的左側採自然本體；受在約 60 厘米處面向取。取雙手握受的兩襟，再將兩襟一併交右手握持，食指插於兩襟之間。',
    },
    'koshiki-yudachi-2': {
      text: '受左腳前進，以左手托取的右肘下側。取右腳後退。受右腳大步前進，嘗試以右手握取左髖側，並以腰投摔出取。',
    },
    'koshiki-yudachi-3': {
      text: '取左手握受的右臂，將其夾於左腋下；左腳後退，左膝著榻榻米，雙手將受向前下方拉倒。',
    },
    'koshiki-taki-otoshi-1': {
      text: '取移至中央，在正面的右側採自然本體；受在約 60 厘米處面向取。取雙手握受的兩襟，再將兩襟一併交右手握持，食指插於兩襟之間。',
    },
    'koshiki-taki-otoshi-2': {
      text: '受左腳前進，以左手托取的右肘下側。取右腳後退。受右腳大步前進，右手越過取的左肩，嘗試握取腰帶後側，以腰投摔出取。',
    },
    'koshiki-taki-otoshi-3': {
      text: '取向左轉身，左手抱受的髖部，向左後方推受數步，使其失去平衡。受向後失去平衡，左腳稍退，嘗試恢復姿勢。',
    },
    'koshiki-taki-otoshi-4': {
      text: '取改變攻擊方向，左手移至受背部右側，右手食指仍在受的兩襟之間，將受的身體向前抬起。受左腳前進一步。',
    },
    'koshiki-taki-otoshi-5': {
      text: '取向內轉身，左腳退至右腳旁，再小步後退數步。受斜向越過取的身體被摔出；取張開雙臂及雙腿，呈大字形。',
    },
    'koshiki-mi-kudaki-1': {
      text: '取在「夢中」起始位置後方一步處，以自然本體面向正面。受在「夢中」的原起始位置，以自然本體面向取。',
    },
    'koshiki-mi-kudaki-2': {
      text: '受從左腳起前進六步，右腳置於取的左腳正前方；右手握取腰帶後側，左手握前側。受嘗試以左腳擊取的右膝蓋，左腳向後擺，雙手用力拉。',
    },
    'koshiki-mi-kudaki-3': {
      text: '取右手從上方握受的左手腕，解除受左手的握持。取轉動左手，使小指側朝上，左臂伸入受的左腋下，將受的身體向後上方推；以左腳帶動繼足，小步向左後方移動數步。',
    },
    'koshiki-mi-kudaki-4': {
      text: '受向後失去平衡，左腳稍退，嘗試恢復姿勢，再左腳前進一步。取改變攻擊方向，右腳移至受右腳外側，在受雙腿下方仰身倒下。',
    },
    'koshiki-mi-kudaki-5': {
      text: '受斜向越過取的身體被摔出並站起。',
    },
    'koshiki-kuruma-gaeshi-1': {
      text: '取與受在斜線上相對站立，取位於正面的左側，雙方迅速接近。受以雙手推取的雙肩。取雙手置於受的上臂下側，拇指朝外。',
    },
    'koshiki-kuruma-gaeshi-2': {
      text: '依左腳、右腳順序踏至受右腳外側，仰身倒下。受斜向越過取的身體被摔出並站起。',
    },
    'koshiki-mizu-iri-1': {
      text: '取與受在斜線上相對站立，取位於正面的左側，雙方迅速接近。受右腳前進，以右手推取的左肩側。',
    },
    'koshiki-mizu-iri-2': {
      text: '取左掌向外轉，從內側握受的右手腕；右掌朝上、拇指朝內，置於受的右腋下。取依左腳、右腳順序踏至受右腳外側，仰身倒下。受斜向越過取的身體被摔出並站起。',
    },
    'koshiki-ryusetsu-1': {
      text: '取與受在斜線上相對站立，取位於正面的右側。受前進數步，取快速前進數步，雙方接近。取右腳前進，右手手背朝上、指尖向下，抬向受的臉部雙眼。',
    },
    'koshiki-ryusetsu-2': {
      text: '受頭部稍後仰。取右手握受的左側衣領，左手伸入受的右腋下。',
    },
    'koshiki-ryusetsu-3': {
      text: '依左腳、右腳順序踏至受右腳外側，仰身倒下。受斜向越過取的身體被摔出並站起。',
    },
    'koshiki-sakaotoshi-1': {
      text: '取與受在斜線上相對站立，取位於正面的左側。受前進數步，取快速前進數步，雙方接近。',
    },
    'koshiki-sakaotoshi-2': {
      text: '受左腳前進，左手作手刀，拇指朝上、其餘四指併攏伸直，猛烈突刺取的腹部水月。取右腳後退一步，採左勢。',
    },
    'koshiki-sakaotoshi-3': {
      text: '取右手從上方握受突刺手的手腕，左掌拇指朝上置於受的左上臂內側；保持站姿，將受向下拉倒。受向前作側向翻身。',
    },
    'koshiki-yukiore-1': {
      text: '取向受走數步，受站起時，取轉背向受並向前走。受從後跟隨。',
    },
    'koshiki-yukiore-2': {
      text: '右腳踏至取右腳外側，嘗試以雙臂從取雙臂上方環抱其身體。取張開雙臂，從上方控制受的右臂：右手置於受的上臂，左手置於前臂。',
    },
    'koshiki-yukiore-3': {
      text: '取右膝著榻榻米，降低身體，將受從自己的背上摔出。受向前翻身。',
    },
    'koshiki-iwa-nami-1': {
      text: '受迅速站起面向取。取向受走一兩步，雙手手背朝上抬向受的臉，對雙眼作目潰式攻擊。受頭部稍後仰。',
    },
    'koshiki-iwa-nami-2': {
      text: '受頭部回正時，取雙手握受的兩側衣領，抬起受的身體使其失去平衡。',
    },
    'koshiki-iwa-nami-3': {
      text: '依左腳、右腳順序踏至受右腳外側，仰身倒下。受斜向越過取的身體被摔出；取在榻榻米上張開雙臂及雙腿，呈大字形。',
    },
  },
}
